import { QFormControl, QInput, QCheckbox } from '@qualio/ui-components';
import React, { SyntheticEvent, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

type GroupFormProps = {
  handleSubmit: (e: SyntheticEvent) => void;
  currentGroupNames: string[];
  groupName: string;
  isIncludedInReports: boolean;
  setGroupName: Function;
  setIncludeInReports: Function;
  setFormValid: Function;
};

export const GroupForm: React.FC<GroupFormProps> = ({
  handleSubmit,
  groupName,
  isIncludedInReports,
  currentGroupNames,
  setGroupName,
  setIncludeInReports,
  setFormValid,
}) => {
  const { t } = useTranslation();
  const init = useRef(true);
  const [groupErrorMsg, setGroupErrorMsg] = useState('');
  const [formValidation, setFormValidation] = useState({
    isValidGroupName: true,
  });

  const validateGroupName = (): boolean => {
    const isValidLength = !!groupName.trim();
    const isUniqueGroupName = !currentGroupNames.includes(groupName.toLowerCase().trim());
    if (!isValidLength) {
      setGroupErrorMsg(t('groupForm.minLengthError'));
    }
    if (!isUniqueGroupName) {
      setGroupErrorMsg(t('groupForm.duplicateError', { groupName: groupName.trim() }));
    }
    setFormValidation({ isValidGroupName: isValidLength && isUniqueGroupName });
    setFormValid(isValidLength && isUniqueGroupName);
    return isValidLength && isUniqueGroupName;
  };

  useEffect(() => {
    if (init.current && !groupName) {
      init.current = false;
      return;
    }
    validateGroupName();
    init.current = false;
  }, [groupName]);

  return (
    <form id="groupForm" aria-label={t('aria.groupForm')} onSubmit={handleSubmit}>
      <QFormControl
        pb="2"
        label={t('groupForm.groupName')}
        size="sm"
        helper={!formValidation.isValidGroupName ? groupErrorMsg : ''}
      >
        <QInput
          data-cy="name-input"
          placeholder={t('groupForm.groupName')}
          aria-label={t('aria.groupName')}
          value={groupName}
          onChange={(e) => setGroupName(e.target.value)}
          isInvalid={!formValidation.isValidGroupName}
        />
      </QFormControl>
      <QFormControl size="sm">
        <QCheckbox
          data-cy="in-reports-checkbox"
          aria-label={t('aria.includeInReports')}
          isChecked={isIncludedInReports}
          onChange={(e) => setIncludeInReports(e.target.checked)}
        >
          {t('groupForm.includeInReports')}
        </QCheckbox>
      </QFormControl>
    </form>
  );
};
